import { render } from "./DocumentPage.vue?vue&type=template&id=5992d8d6&scoped=true"
import script from "./DocumentPage.vue?vue&type=script&lang=js"
export * from "./DocumentPage.vue?vue&type=script&lang=js"

import "./DocumentPage.vue?vue&type=style&index=0&id=5992d8d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5992d8d6"]])

export default __exports__